module.exports = {
    Auth: {
        region: process.env.VUE_APP_USER_POOL_REGION,
        userPoolId: process.env.VUE_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID,
        authenticationFlowType: 'USER_PASSWORD_AUTH',
    }
}
